export default {
    title: "Verifikacija prodavnice",
    subtitle: "Kada ispunite formu naši moderatori će provjeriti podatke i odobriti verifikovani status.",
    back: "Nazad",
    address: {
        title: "Adresa firme",
        city: {
            title: "Grad",
            placeholder: "Odaberi grad"
        },
        street: {
            title: "Ulica",
            placeholder: "Naziv ulice"
        },
        number: {
            title: "Broj",
            placeholder: "###"
        }
    },
    authorizedPerson: {
        title: "Ovlašćeno lice",
        name: {
            title: "Ime",
            placeholder: "Unesi ime"
        },

        surname: {
            title: "Prezime",
            placeholder: "Unesi prezime"
        },

        idCard: {
            title: "Broj lične karte",
            placeholder: "###"
        },
    },
    companyDetails: {
        title: "Podaci o firmi",
        vat: {
            title: "PDV",
            placeholder: "Unesi PDV"
        },
        pib: {
            title: "PIB",
            placeholder: "Unesi PIB"
        },
        revenue: {
            title: "Prošlogodišnji prihod",
            placeholder: "###"
        }

    },
    verifyButton: "Verifikuj",
    successMessage: "Uspješno ste poslali zahtjev za verifikaciju preduzeća."
}
